import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useTheme } from '../../context/MagicBellThemeContext.js';
import FooterLogo from './FooterLogo.js';
import StyledFooter from './StyledFooter.js';
/**
 * Footer for the notification inbox. Renders a button to toggle the user
 * preferences panel.
 *
 * @example
 * <Footer />
 */
export default function Footer({ children }) {
    const theme = useTheme();
    const { footer: footerTheme } = theme;
    const contentStyle = css `
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: ${footerTheme.textColor} !important;

    a,
    button {
      color: ${footerTheme.textColor};
      display: block;
    }

    a {
      opacity: 0.85;
    }
  `;
    return (_jsx(StyledFooter, { children: _jsxs("div", { css: contentStyle, children: [_jsx(FooterLogo, {}), children] }) }));
}
//# sourceMappingURL=Footer.js.map